import { ITrainingApprovalHelpQuery } from '../interfaces/training-approval-help.query.interface';

export class TrainingApprovalHelp {
    formType: string;
    nameTranslations: {
        'translation_en-GB': string;
        'translation_de-DE': string;
        'translation_fr-FR': string;
        'translation_it-CH': string;
    };
    urlTranslations: {
        'translation_en-GB': string;
        'translation_de-DE': string;
        'translation_fr-FR': string;
        'translation_it-CH': string;
    };

    constructor(query: ITrainingApprovalHelpQuery) {
        this.formType = query.form_type;
        this.nameTranslations = query.name_translations;
        this.urlTranslations = query.url_translations;
    }
}
